<template>
	<div class="w-full">
		<div
			class="relative mt-8 flex h-[440px] items-center overflow-clip rounded from-[#0078BF] via-[#456BB5] to-[#7B61AE] bg-gradient-[-30deg] md:h-[200px] xl:h-[230px]"
		>
			<CarbarImage
				image="img/campaigns/july-novated-2025/arrow.webp"
				alt-text="July Novated Flex for Business"
				image-width-class="w-full lg:w-[700px]"
				image-height-class="h-auto"
				class="absolute left-0 top-12 opacity-50 sm:top-0"
			/>
			<div
				class="absolute bottom-0 left-0 h-[340px] w-full from-[#ffffff]/0 to-[#ffffff]/25 bg-gradient-[-60deg] sm:h-[350px] md:h-[95px] md:w-[50%] lg:h-[100px] xl:h-[130px]"
			/>

			<div
				class="flex w-full flex-col items-center justify-center gap-2 md:flex-row md:gap-0 xl:gap-8"
			>
				<div
					class="relative -top-8 w-full sm:-top-10 sm:left-20 md:left-5 md:w-1/3"
				>
					<CarbarImage
						image="img/campaigns/july-novated-2025/car-back.webp"
						alt-text="Honda Civic"
						image-width-class=" w-[180px] sm:w-[200px] md:w-[140px] lg:w-[233px]"
						image-height-class="h-auto"
						class="slide-in-from-left delay-4 relative left-5 top-9"
					/>
					<CarbarImage
						image="img/campaigns/july-novated-2025/car-front.webp"
						alt-text="Honda Civic"
						image-width-class="w-[300px] sm:w-[330px] lg:w-[419px]"
						image-height-class="h-auto"
						class="slide-in-from-right absolute left-14 top-0 sm:left-20 sm:top-0 md:left-0 md:top-6 xl:left-15 xl:top-0"
					/>
				</div>
				<div
					class="w-full px-6 md:w-2/3 md:px-0 lg:pl-0 lg:pr-10 xl:px-6 xl:pr-10"
				>
					<div class="flex flex-col">
						<p
							class="text-center font-heading text-[1.875rem] leading-none text-white sm:text-[2.2rem] md:text-left md:text-[1.6rem] lg:text-[1.9rem] xl:text-[2.2rem]"
						>
							Novated Flex for Business:
						</p>
						<p
							class="text-center text-[1.5rem] text-white sm:text-[2rem] md:text-left md:text-[1.6rem] lg:text-[1.7rem]"
						>
							No more locked-in lease.
						</p>
					</div>
					<div
						class="relative mt-4 flex w-full flex-row items-start gap-2 sm:mt-6 sm:gap-6 md:-left-5 md:mt-2 md:items-start md:gap-0 lg:items-center xl:mt-4"
					>
						<div
							class="slide-in-from-bottom delay-1 flex w-1/3 flex-col items-center md:w-[150px] md:flex-row md:items-start lg:w-full"
						>
							<CarbarImage
								image="img/campaigns/july-novated-2025/icon-1.webp"
								alt-text="10% off Novated Subscription"
								image-width-class="w-[80px]"
								image-height-class="h-[63px]"
								class=""
							/>
							<p
								class="relative -top-2 text-center text-base font-medium leading-none text-white sm:text-lg sm:leading-tight md:-left-2 md:top-0 md:w-full md:text-left md:text-sm md:leading-none lg:top-1 lg:min-w-[170px] lg:text-base"
							>
								10% off
								<br class="hidden xl:block" />
								Novated Subscription
							</p>
						</div>
						<div
							class="slide-in-from-bottom delay-2 flex w-1/3 flex-col items-center md:w-[160px] md:flex-row md:items-start lg:w-full"
						>
							<CarbarImage
								image="img/campaigns/july-novated-2025/icon-2.webp"
								alt-text="Tax-effective for business & empoloyees"
								image-width-class="w-[80px]"
								image-height-class="h-[62px]"
								class=""
							/>
							<p
								class="relative -top-2 text-center text-base font-medium leading-none text-white sm:text-lg sm:leading-tight md:-left-2 md:top-0 md:w-full md:text-left md:text-sm md:leading-none lg:top-1 lg:min-w-[130px] lg:text-base"
							>
								Tax-effective for
								<br class="hidden xl:block" />
								business & employees
							</p>
						</div>
						<div
							class="slide-in-from-bottom delay-3 flex w-1/3 flex-col items-center md:w-[190px] md:flex-row md:items-start lg:w-full"
						>
							<CarbarImage
								image="img/campaigns/july-novated-2025/icon-3.webp"
								alt-text="Full flexibility to cancel or swap with short notice"
								image-width-class="w-[81px]"
								image-height-class="h-[63px]"
								class=""
							/>
							<p
								class="relative -top-2 w-full text-center text-base font-medium leading-none text-white sm:text-lg sm:leading-tight md:-left-2 md:top-0 md:w-full md:text-left md:text-sm md:leading-none lg:top-1 lg:min-w-[150px] lg:text-base"
							>
								Full flexibility to cancel
								<br class="hidden xl:block" />
								or swap with short notice
							</p>
						</div>
					</div>
					<TermsAndConditions
						:is-full-width="false"
						custom-class="relative z-10 mt-4 md:mt-0 sm:mt-8 sm:text-center xl:text-left"
						font-color="text-white"
					>
						*
						<CarbarLink
							text="Terms & conditions"
							text-color="text-white hover:text-gray-200"
							underline-color="hover:decoration-gray-200"
							font-size="text-xsm"
							class="cursor-pointer"
							@click="
								goToPageAndScroll(
									'/terms-and-conditions',
									'#july-novated-promotion',
									true
								)
							"
						/>
						apply
					</TermsAndConditions>
				</div>
			</div>

			<NuxtLink to="/business/novated-subscription">
				<div
					class="absolute bottom-5 right-0 z-10 rounded-l bg-gray-700 px-4 py-2 transition-all duration-300 hover:bg-black hover:px-8"
				>
					<span class="font-medium leading-none text-white">
						Find out more
					</span>
				</div>
			</NuxtLink>
		</div>
	</div>
</template>

<script setup>
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'

const mounted = ref(false)

onMounted(() => {
	setTimeout(() => {
		mounted.value = true
	}, 50)
})
</script>
